const $kutil = require('./kutil');
const $kstore = {
	
    set: function(key,val,expSeconds){   
		var mywindow = $kutil.getTopWindow();
		if( mywindow.mystoreimpl ){
			return mywindow.mystoreimpl.set(key,val,expSeconds);
		}else{
			return false;
		}
    },
    get: function(key){    
		var mywindow = $kutil.getTopWindow();
		if( mywindow.mystoreimpl ){
			return mywindow.mystoreimpl.get(key);
		}else{
			return null;
		}
    },
	gets: function(keys){  
		var mywindow = $kutil.getTopWindow();
		if( mywindow.mystoreimpl ){
			var result = {};
			for(var i = 0;i<keys.length;i++){
				var key = keys[i];
				result[key] = mywindow.mystoreimpl.get(key);
			}
			return result;
		}else{
			return null;
		}
    },
    del: function(key){  
		var mywindow = $kutil.getTopWindow();
		if( mywindow.mystoreimpl ){
			return mywindow.mystoreimpl.del(key);
		}else{
			return false;
		}
    },
    isExp: function(key){ 
		var mywindow = $kutil.getTopWindow();
		if( mywindow.mystoreimpl ){
			return mywindow.mystoreimpl.isExp(key);
		}else{
			return true;
		}
    } 
};
var mystoreimpl = {
    storeCache:{},
    set: function(key,val,expSeconds){
      if(key && key.trim().length>0){
        this.storeCache[key] = {val:val, expTime: new Date().getTime() + expSeconds*1000};
        return true;
      } else {
        return false;
      }
    },
    get: function(key){
      if(key && key.trim().length>0){
        if( this.storeCache[key] && !this.isExp(key) ){
          return this.storeCache[key].val;

        } 
        return null;
      } else {
        return null;
      }
    },
    del: function(key){
      if(key && key.trim().length>0){
        delete this.storeCache[key];
        return true;
      }
      return false;
    },
    isExp: function(key){
      if(key && key.trim().length>0){
        return this.storeCache[key].expTime < new Date().getTime();
      }
	  return true;
    } 
};
top.mystoreimpl = mystoreimpl;
module.exports = $kstore;